var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle2, _circle3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 267,
    viewBox: "0 0 320 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.217,
    cy: 261.387,
    rx: 189.813,
    ry: 189.273,
    transform: "rotate(122.112 261.217 261.387)",
    fill: "url(#paint0_radial_1392_3804)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 261.122,
    cy: 261.54,
    r: 154.729,
    transform: "rotate(122.112 261.122 261.54)",
    fill: "#EA1889"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C210.666 412.552 248.631 420.267 285.693 414.306C322.756 408.345 356.387 389.113 380.321 360.194C404.255 331.275 416.86 294.642 415.788 257.118C414.715 219.595 400.038 183.742 374.49 156.237C348.943 128.733 314.268 111.454 276.926 107.62C239.584 103.786 202.121 113.658 171.517 135.397C140.914 157.135 119.257 189.258 110.581 225.781C101.906 262.303 106.803 300.734 124.361 333.913L261.122 261.54L178.87 392.597Z",
    fill: "#9F18D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C207.72 410.703 241.739 418.784 275.649 415.586C309.56 412.388 341.468 398.09 366.424 374.909C391.381 351.728 407.991 320.96 413.678 287.377C419.366 253.794 413.813 219.273 397.882 189.167C381.95 159.062 356.53 135.054 325.563 120.869C294.596 106.683 259.814 103.112 226.611 110.709C193.408 118.305 163.639 136.646 141.922 162.886C120.205 189.126 107.753 221.799 106.498 255.837L261.122 261.54L178.87 392.597Z",
    fill: "#57F2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C204.791 408.865 234.953 417.081 265.543 416.206C296.133 415.332 325.777 405.406 350.726 387.684C375.675 369.962 394.808 345.239 405.707 316.643C416.605 288.047 418.779 256.861 411.953 227.03C405.128 197.198 389.609 170.06 367.36 149.048C345.112 128.036 317.132 114.093 286.959 108.983C256.786 103.873 225.775 107.825 197.848 120.339C169.922 132.854 146.333 153.368 130.065 179.289L261.122 261.54L178.87 392.597Z",
    fill: "#EA1889"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C201.875 407.035 228.276 415.163 255.418 416.164C282.56 417.165 309.488 411.004 333.494 398.3C357.501 385.596 377.74 366.797 392.178 343.792C406.616 320.786 414.745 294.386 415.746 267.244C416.747 240.101 410.586 213.174 397.882 189.167C385.178 165.161 366.378 144.922 343.373 130.483C320.368 116.045 293.967 107.917 266.825 106.916C239.683 105.915 212.755 112.076 188.749 124.78L261.122 261.54L178.87 392.597Z",
    fill: "#9F18D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C198.973 405.213 221.708 413.036 245.317 415.46C268.927 417.884 292.778 414.845 315.024 406.577C337.271 398.309 357.318 385.034 373.614 367.779C389.909 350.524 402.017 329.752 409.001 307.069C415.984 284.386 417.656 260.401 413.887 236.968C410.118 213.536 401.009 191.285 387.265 171.936C373.521 152.587 355.51 136.659 334.625 125.385C313.741 114.11 290.543 107.791 266.825 106.916L261.122 261.54L178.87 392.597Z",
    fill: "#57F2B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C213.629 414.411 255.629 421.524 295.632 412.372C335.635 403.219 370.364 378.55 392.178 343.792C413.993 309.033 421.106 267.033 411.953 227.03C402.8 187.027 378.131 152.298 343.373 130.483L261.122 261.54L178.87 392.597Z",
    fill: "#EA1889"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C207.72 410.703 241.739 418.784 275.649 415.586C309.56 412.388 341.468 398.09 366.424 374.909C391.381 351.728 407.991 320.96 413.678 287.377C419.366 253.794 413.813 219.273 397.882 189.167L261.122 261.54L178.87 392.597Z",
    fill: "#9F18D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C201.875 407.035 228.276 415.163 255.418 416.164C282.56 417.165 309.488 411.004 333.494 398.3C357.501 385.596 377.74 366.797 392.178 343.792C406.616 320.786 414.745 294.386 415.746 267.244L261.122 261.54L178.87 392.597Z",
    fill: "#57F2B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C196.081 403.398 215.25 410.704 235.284 414.097C255.318 417.49 275.825 416.904 295.632 412.372C315.44 407.84 334.161 399.451 350.726 387.684C367.291 375.917 381.377 361.002 392.178 343.792L261.122 261.54L178.87 392.597Z",
    fill: "#EA1889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C201.875 407.035 228.276 415.163 255.418 416.164C282.56 417.165 309.488 411.004 333.494 398.3L261.122 261.54L178.87 392.597Z",
    fill: "#9F18D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M178.87 392.597C201.875 407.035 228.276 415.163 255.418 416.164L261.122 261.54L178.87 392.597Z",
    fill: "#57F2B9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.37,
    cy: 261.483,
    r: 25.0086,
    transform: "rotate(122.112 261.37 261.483)",
    fill: "#D396ED"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 261.37,
    cy: 261.483,
    r: 14.9332,
    transform: "rotate(122.112 261.37 261.483)",
    fill: "#57F2B9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1392_3804",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.925 -63.6622) rotate(47.6614) scale(659.165 661.044)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169475,
    stopColor: "#4B00CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B00CC",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottom-right.3171fd250ab56301125c65d40a7a50ad.svg";
export { ForwardRef as ReactComponent };